/** @jsx jsx */
import React from "react"
import { jsx } from 'theme-ui'

import { QuizzContext } from "@bit/dweez.perso.quizz.contexts"
import ResetButton from "@bit/dweez.perso.quizz.reset-button"

export default props => {
  const [state] = React.useContext(QuizzContext)
  return state.inviteReset ? (
    <p
      sx={{
        textAlign: "center",
        padding: "3rem",
        marginBottom: "6rem",
        backgroundColor: "highlight",
      }}
    >
      <ResetButton
        debug
        label="Changement de questionnaire demandé: reset obligatoire"
      />
    </p>
  ) : (
    <></>
  )
}
